module.exports = __webpack_public_path__ + "media/src/images/step07-8383eec223c13548edeb3ef78e0c1b41.png";